import React from 'react' 
import UseLang from '../../../../hooks/UseLang'

function BuenasPracticas() {
    return (
        <div id="p4">
            <UseLang es>
                <h4 id="buenas">Buenas Pr&aacute;cticas</h4>
                <p>Dado que los ataques DDoS se dan debido a la explotaci&oacute;n de vulnerabilidades de las distintas capas
                    del Stack TCP/IP, es importante implementar una protecci&oacute;n integral en la organizaci&oacute;n. Para
                    tal fin, deben conocerse y llevar a cabo distintas acciones que pueden complementar una soluci&oacute;n DDoS
                    y proteger servidores y redes.</p>
                <p>En esta secci&oacute;n se describen las principales acciones que pueden llevarse a cabo desde la
                    organizaci&oacute;n, con el fin de prevenir ataques de DDoS (bajar su probabilidad de ocurrencia o minimizar
                    su impacto).</p>
                <p>Respecto a la configuraci&oacute;n de la red y servicios para reducir la probabilidad de ataques de DDoS y
                    fortalecer la infraestructura frente a estos, es recomendable implementar (si es factible):</p>

                <h5 id="redun">Redundancia y distribuci&oacute;n de carga</h5>
                <p>Utilizar CDN para proteger sitios WEB. Las CDN son redes distribuidas de servidores proxy que permiten
                    reducir la latencia, ya que almacenan contenido en cach&eacute; y lo acercan a los usuarios finales. De esta
                    forma, los ataques de DDoS se mitigar&aacute;n m&aacute;s cerca de la fuente, sin impactar en el
                    rendimiento.</p>

                <h5 id="rate">Rate limiting</h5>
                <p>Limitar la cantidad de solicitudes que un usuario puede hacer en un per&iacute;odo de tiempo
                    espec&iacute;fico para prevenir el abuso.</p>

                <h5 id="fil">Filtrado de tr&aacute;fico</h5>
                <p>Configurar firewalls y sistemas de detecci&oacute;n de intrusiones (IDS) para filtrar tr&aacute;fico
                    malicioso, tanto basados en patrones y firmas conocidas como utilizando aprendizaje autom&aacute;tico.</p>

                <h5 id="any">Anycast routing</h5>
                <p>Utilizar enrutamiento anycast para distribuir el tr&aacute;fico en m&uacute;ltiples ubicaciones, haciendo
                    m&aacute;s dif&iacute;cil para los atacantes concentrar el ataque en un solo punto.</p>

                <h5 id="capacidad">Capacidad de sobrecarga</h5>
                <p>Asegurarse de que la infraestructura pueda manejar una cantidad significativa de tr&aacute;fico adicional
                    mediante el uso de servidores y ancho de banda adicional.</p>

                <h5 id="prot">Protecci&oacute;n en protocolo</h5>
                <p>Configurar correctamente los protocolos de red para mitigar vulnerabilidades que den lugar a ataques de
                    amplificaci&oacute;n y as&iacute; minimizar su impacto <a
                        href="https://blog.lacnic.net/eventos-es/protocolos-que-favorecen-ataques-de-ddos"
                        target="_blank" rel="noreferrer">https://blog.lacnic.net/eventos-es/protocolos-que-favorecen-ataques-de-ddos</a>.</p>

                <h5 id="moni">Respecto al monitoreo y detecci&oacute;n, resultan buenas pr&aacute;cticas:</h5>
                <p>
                    <ol>
                        <li>Contar con sistemas de detecci&oacute;n y respuesta temprana.</li>
                        <li>Implementar soluciones de monitoreo que detecten patrones de tr&aacute;fico inusuales y respondan
                            autom&aacute;ticamente a posibles ataques.</li>
                        <li>Implementar mecanismos para:
                            <ul>
                                <li>Detectar bots maliciosos y bloquear su tr&aacute;fico sin interrumpir el tr&aacute;fico de
                                    usuarios leg&iacute;timos.</li>
                                <li>Implementar mecanismos que permitan diferenciar entre tr&aacute;fico de ataque y tr&aacute;fico
                                    leg&iacute;timo.</li>
                            </ul>
                        </li>
                    </ol>
                </p>
                <p>Si bien diferenciar el tr&aacute;fico de ataque de tr&aacute;fico leg&iacute;timo no es trivial, hay
                    distintas herramientas, proyectos e iniciativas que pueden colaborar en este sentido <a
                        href="https://csirt.lacnic.net/honeynet" target="_blank" rel="noreferrer">https://csirt.lacnic.net/honeynet</a>.</p>

            </UseLang>
            <UseLang en>

                <h4 id="buenas">Best Practices</h4>
                <p>Because DDoS attacks occur when a vulnerability is exploited in the various layers of the TCP/IP Stack, it is important for organizations to implement comprehensive protection. This requires implementing multiple actions to complement a DDoS solution and protect both servers and networks.</p>
                <p>This section outlines the main actions an organization can take to prevent DDoS attacks (either by reducing their likelihood and/or by minimizing their impact).</p>
                <p>In order to enhance network and service configuration to reduce the likelihood of DDoS attacks and strengthen the infrastructure, if feasible, it is advisable to implement the following:</p>

                <h5 id="redun">Redundancy and load distribution</h5>
                <p>Using CDNs to protect websites. A CDN is a geographically distributed network of proxy servers that reduces latency by caching content and bringing it closer to end users. This means DDoS attacks will be mitigated closer to their source, limiting their impact on performance.</p>

                <h5 id="rate">Rate limiting</h5>
                <p>Restricting the number of requests a user can make within a certain time frame to prevent abuse.</p>

                <h5 id="fil">Traffic filtering</h5>
                <p>Configuring firewalls and intrusion detection systems (IDS) to filter out malicious traffic based on known patterns and signatures, as well as by applying machine learning.</p>

                <h5 id="any">Anycast routing</h5>
                <p>Using Anycast routing to distribute traffic across multiple locations, making it more difficult for attackers to focus their attack on a single target.</p>

                <h5 id="capacidad">Overload capacity</h5>
                <p>Ensuring the infrastructure can handle significant traffic surges by using additional servers and increased bandwidth.</p>

                <h5 id="prot">Protocol protection</h5>
                <p>Properly configuring network protocols to mitigate vulnerabilities that may lead to amplification attacks and thus minimize their impact.<a href="https://blog.lacnic.net/eventos-es/protocolos-que-favorecen-ataques-de-ddos" target="_blank" rel="noreferrer">https://blog.lacnic.net/eventos-es/protocolos-que-favorecen-ataques-de-ddos</a>.</p>

                <h5 id="moni">In the case of monitoring and detection, best practices include:</h5>
                <p><ol>
                    <li>Having early detection and response systems.</li>
                    <li>Implementing monitoring solutions that can detect unusual traffic patterns and automatically respond to potential attacks.</li>
                    <li>Implementing mechanisms to:
                        <ul>
                            <li>Detect malicious bots and block their traffic without disrupting legitimate users.</li>
                            <li>Implement mechanisms to distinguish between attack traffic and legitimate traffic.</li>
                        </ul>
                    </li>
                </ol>
                </p>
                <p>While distinguishing attack traffic from legitimate traffic can be challenging, various tools, projects, and initiatives are available that can help <a href="https://csirt.lacnic.net/honeynet" target="_blank" rel="noreferrer">https://csirt.lacnic.net/honeynet</a>.</p>

            </UseLang>
            <UseLang pt>

                <h4 id="buenas">Boas práticas</h4>
                <p>Uma vez que os ataques DDoS ocorrem devido à exploração de vulnerabilidades nas diferentes camadas da pilha TCP/IP, é importante implementar uma proteção abrangente na organização. Para isso, devem se conhecer e realizar diferentes ações que podem complementar uma solução DDoS e proteger servidores e redes.</p>
                <p>Nesta seção são descritas as principais ações que podem ser feitas pela organização para prevenir ataques de DDoS (diminuir a sua probabilidade de ocorrência ou minimizar o seu impacto).</p>
                <p>Quanto à configuração da rede e dos serviços para reduzir a probabilidade de ataques de DDoS e fortalecer a infraestrutura contra estes, é aconselhável implementar (se viável):</p>

                <h5 id="redun">Redundância e distribuição de carga</h5>
                <p>Usar CDN para proteger sites WEB. As CDN são redes distribuídas de servidores proxy que permitem reduzir a latência, uma vez que armazenam conteúdo em cachê e o aproximam aos usuários finais. Dessa forma, os ataques de DDoS serão mitigados mais perto da fonte sem afetar o desempenho.</p>

                <h5 id="rate">Rate limiting</h5>
                <p>Limitar o número de pedidos que um usuário pode fazer em um período específico para evitar abusos.</p>

                <h5 id="fil">Filtragem de tráfego</h5>
                <p>Configurar firewalls e sistemas de detecção de intrusões (IDS) para filtrar o tráfego malicioso com base em padrões e assinaturas conhecidas, bem como usando aprendizado automático.</p>

                <h5 id="any">Anycast routing</h5>
                <p>Usar roteamento Anycast para distribuir o tráfego em vários locais, tornando mais difícil para os atacantes concentrarem o ataque em um único ponto.</p>

                <h5 id="capacidad">Capacidade de sobrecarga</h5>
                <p>Certificar-se de que a infraestrutura possa lidar com uma quantidade significativa de tráfego adicional mediante o uso de servidores e largura de banda adicional.</p>

                <h5 id="prot">Proteção em protocolo</h5>
                <p>Configurar corretamente os protocolos de rede para mitigar vulnerabilidades que levem a ataques de amplificação e, assim, minimizar o seu impacto <a href="https://blog.lacnic.net/eventos-es/protocolos-que-favorecen-ataques-de-ddos" target="_blank" rel="noreferrer">https://blog.lacnic.net/eventos-es/protocolos-que-favorecen-ataques-de-ddos</a>.</p>

                <h5 id="moni">Em relação ao monitoramento e detecção, resultam boas práticas:</h5>
                <p><ol>
                    <li>Dispor de sistemas de detecção e resposta precoces.</li>
                    <li>Implementar soluções de monitoramento que detectem padrões de tráfego incomuns e respondam automaticamente a possíveis ataques.</li>
                    <li>Implementar mecanismos para:
                        <ul>
                            <li>Detectar bots maliciosos e bloquear seu tráfego sem interromper o tráfego de usuários legítimos.</li>
                            <li>Implementar mecanismos que permitam a diferenciação entre tráfego de ataque e tráfego legítimo.</li>
                        </ul>
                    </li>
                </ol>
                </p>
                <p>Embora diferenciar o tráfego de ataque do tráfego legítimo não seja trivial, existem diferentes ferramentas, projetos e iniciativas que podem colaborar nesse sentido <a href="https://csirt.lacnic.net/honeynet" target="_blank" rel="noreferrer">https://csirt.lacnic.net/honeynet</a>.</p>

            </UseLang>
        </div>
    )
}

export default BuenasPracticas
